import { Button, Icon } from "@lysaab/ui-2";
import { FunctionComponent } from "react";

interface Props {
  onSave: () => void;
  isLoading: boolean;
}

export const SaveButton: FunctionComponent<Props> = ({ onSave, isLoading }) => {
  return (
    <Button
      onClick={onSave}
      disabled={isLoading}
      label={
        <>
          <strong>Save changes</strong>
          {isLoading ? (
            <div className="ms-3 spinner-border spinner-border-sm">
              <span className="sr-only"></span>
            </div>
          ) : (
            <Icon.Withdrawal size={16} />
          )}
        </>
      }
    />
  );
};
